import { Typography } from "@bigbinary/neeto-atoms";
import { globalProps } from "neetocommons/initializers";
import PropTypes from "prop-types";
import { Trans as ReactTrans } from "react-i18next";

const Trans = ({
  i18nKey,
  additionalValues = {},
  additionalComponents = {},
}) => (
  <ReactTrans
    {...{ i18nKey }}
    components={{
      Code: (
        <Typography asChild variant="body3">
          <code className="bg-muted rounded-md px-1.5 py-0.5" />
        </Typography>
      ),
      Semibold: (
        <Typography asChild variant="body2" weight="medium">
          <span className="inline" />
        </Typography>
      ),
      ...additionalComponents,
    }}
    values={{
      productSuffix: globalProps.appName,
      ...additionalValues,
    }}
  />
);

Trans.propTypes = {
  i18nKey: PropTypes.string.isRequired,
  additionalValues: PropTypes.object,
  additionalComponents: PropTypes.objectOf(PropTypes.element),
};

export default Trans;
